'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class ParagraphWithImage {

	constructor($target) {

		//Private properties
		$target;
		
		let name = "HELLO";

		function init(){			
			playVideoBtn()			
		}

		function playVideoBtn(){
			var videoBtn = $target.find('.block_paragraph_with_image__play_button');
			videoBtn.on('click', onClickEvent)
		}
		
	
		function onClickEvent(){

			//play video form youtube
			// $(this).siblings('.block_paragraph_with_image_thumbnail_container').css('.video__src > iframe')[0].src += "?autoplay=1"
			$(this).siblings('.block_paragraph_with_image_thumbnail_container').css('visibility', 'hidden');

			//show video iframe
			$(this).siblings('.block_paragraph_with_image__play_button_iframe_container').find('.block_paragraph_with_image__play_button_iframe_src')[0].src += "?autoplay=1"
			
			$(this).siblings('.block_paragraph_with_image__play_button_iframe_container').css('visibility', 'visible')	

			//hide thumbnail
			// $(this).siblings('.video__thumbnail').find('.video__thumbnail__img').css('visibility', 'hidden')
			// $(this).siblings('.video__thumbnail').find('.video__thumbnail__img').hide()
		

			// $(this).find('.block_latest_videos__play_button').css('visibility', 'hidden')


			// $(this).find('.block_latest_videos__play_button').hide()
			
		}
		

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default ParagraphWithImage;